Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.location = exports.metrics = undefined;
var _propTypes = require("prop-types");
var metrics = exports.metrics = _propTypes.object; /* eslint-disable prettier/prettier */
var location = exports.location = (0, _propTypes.shape)({
  pathname: _propTypes.string.isRequired,
  search: _propTypes.string.isRequired,
  query: _propTypes.object,
  state: _propTypes.object
});
exports.default = {
  metrics: metrics,
  location: location
};